export class DuplicateEmailsManager {

    static findDuplicateEmails(csvContent: string): string[] {
        const lines = csvContent.split('\n');

        // header line
        const emailColumnIndex = this.getEmailColumnIndex(lines[0]);

        if (emailColumnIndex === -1) {
            console.warn('Email column not found');
            return [];
        }

        const emails: string[] = [];
        const duplicates: string[] = [];

        lines.slice(1).forEach(line => {
            if (!line.trim()) return; // ignore empty lines

            const columns = line.split(',');
            const email = columns[emailColumnIndex]?.trim().toLowerCase();

            if (email) {
                if (emails.includes(email)) {
                    if (!duplicates.includes(email)) {
                        duplicates.push(email);
                    }
                } else {
                    emails.push(email);
                }
            }
        });

        return duplicates;
    }

    static getEmailColumnIndex(headerLine: string): number {
        const headers = headerLine.split(',').map(h => h.trim().toLowerCase());
        // search email column
        const emailHeaders = ['email'];

        for (const emailHeader of emailHeaders) {
            const index = headers.indexOf(emailHeader);
            if (index !== -1) return index;
        }

        return -1; // not found
    }
}